import { render, staticRenderFns } from "./big-img.vue?vue&type=template&id=28a010d2&scoped=true"
import script from "./big-img.vue?vue&type=script&lang=js"
export * from "./big-img.vue?vue&type=script&lang=js"
import style0 from "./big-img.vue?vue&type=style&index=0&id=28a010d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a010d2",
  null
  
)

export default component.exports